module.exports = "/images/ny-blck-4.jpg";